module.exports = __webpack_public_path__ + "img/kwaiProDownload5.c87a6b8.png";